import { defineStore } from "pinia";
import { computed } from "vue";
import { t } from "@/i18n";
import { makeLogger } from "@/shared/consola";
import SvgTimerLayoutBasic from "@/apps/timer/project/onboarding/svg-previews/SvgTimerLayoutBasic.vue";
import { useOnboarding } from "@/shared/projects/onboarding/useOnboarding";
import { useActions, useMutations, useState } from "@/store/vuex-composition-mappers";
import { useTimerSetup } from "@/apps/timer/project/useTimerSetup";
import { mapThemeToTimerColors } from "@/shared/projects/prepare-theme";

const STORE_NAME = "timer-creator";
const logger = makeLogger("🍍" + STORE_NAME);

export const useTimerCreatorStore = defineStore(STORE_NAME, () => {
    logger.trace("👋hello ONCE ?");

    const { timer } = useState("timer", ["timer"]);
    const { decorateTimerWithEndDate } = useTimerSetup();
    const { saveSnapshot } = useActions("timer", ["saveSnapshot"]);
    const { showAlert } = useMutations(["showAlert"]);

    const {
        isCreatorShown,
        onboardState,
        previewCssVars,
        autoOpenCreator,
        toggleCreatorShown,
        updateProductInfo,
        validate,
    } = useOnboarding({
        initialValues: {
            hidePrompt: true,
        },
    }); /*{
        autoOpenRules: ({ endDate, createdAt }) => {
            if (endDate && createdAt) {
                const eM = moment(endDate);
                const cM = moment(createdAt);
                // when createdAt date is less than 5 seconds than timer endDate -> open the Onboarding
                return eM.diff(cM, "seconds") < 5;
            }
            return false;
        },
    }*/

    const templates = computed(() => []);

    const layouts = computed(() => []);

    const previewComponent = computed(() => SvgTimerLayoutBasic);

    return {
        onboardState,
        isCreatorShown,
        templates,
        layouts,
        previewCssVars,
        previewComponent,
        links: computed(() => ({
            video: "",
            docs: "",
        })),
        autoOpenCreator,
        onboardingAction(resolveResponse) {
            return async () => {
                if (!validate()) {
                    return;
                }
                try {
                    const endDate = await resolveResponse();
                    const { theme, layout } = onboardState;
                    logger.debug("about to fillWithExample", { theme, layout });
                    for (const [key, value] of Object.entries(mapThemeToTimerColors(theme))) {
                        timer.value[key] = value;
                    }
                    if (endDate) {
                        decorateTimerWithEndDate(endDate, timer.value);
                    }
                    showAlert({
                        type: "success",
                        title: t("shared.creator.generation_success"),
                    });
                    await saveSnapshot();
                    toggleCreatorShown(false);
                } catch (e) {
                    logger.error(e);
                }
            };
        },
        toggleCreatorShown,
        updateProductInfo,
        validate,
    };
});
